import React from "react";
import "./BusyOverlay.css";

interface BusyOverlayProps {
  isVisible: boolean;
  message?: string;
}

const BusyOverlay: React.FC<BusyOverlayProps> = ({
  isVisible,
  message = "Loading...",
}) => {
  if (!isVisible) return null;

  return (
    <div className="busy-overlay">
      <div className="busy-overlay__content">
        <div className="spinner"></div>
        <p className="busy-overlay__message">{message}</p>
      </div>
    </div>
  );
};

export default BusyOverlay;
